function TripChatMobileSurface() {
  return null
}

export default TripChatMobileSurface
